module.exports = require("@mario-kart/domain").RuleLogic;
